import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's124g-s124m01',
    templateUrl: './s124g-s124m01.component.html'
})
export class S124gS124m01Component extends Overlay {
    scrndat: any = {};
    scrntim: any = {};
    blnk1: any = {'value': 'OPTIONAL DATE RANGE:'};
    blnk2: any = {'value': 'FROM              TO'};
    crittyp: any = {};
    critdat: any = {};
    frmmm: any = {};
    blnk3: any = {'value': '\/'};
    frmdd: any = {};
    blnk4: any = {'value': '\/'};
    frmyy: any = {};
    tomm: any = {};
    blnk5: any = {'value': '\/'};
    todd: any = {};
    blnk6: any = {'value': '\/'};
    toyy: any = {};
    blnk7: any = {'value': 'PNR#:'};
    pnrno: any = {};
    blnk8: any = {'value': 'CREATION DATE:'};
    crdate: any = {};
    pnrmsg: any = {};
    prnt: any = {'value': '________'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndat', 'scrntim', 'blnk1', 'blnk2', 'crittyp', 'critdat', 'frmmm', 'blnk3', 'frmdd', 'blnk4', 'frmyy', 'tomm', 'blnk5', 'todd', 'blnk6', 'toyy', 'blnk7', 'pnrno', 'blnk8', 'crdate', 'pnrmsg', 'prnt', 'msgln'];
    public LINES: number[] = [16, 1, 2, 18, 5, 6, 22, 7, 23, 24, 9];

    ngAfterViewInit(): void {
    }
    onEnter() {
        // if (this.msgln.value) {
        //     if (this.msgln.value.trim() == 'NO PRINTER ID ENTERED - PLEASE ENTER PRINTER ID OR "NONE"' || this.msgln.value.trim() == 'INVALID PRINTER ID, PLEASE RE-ENTER') {
        //         const input = document.querySelector('#prnt');
        //         (input as HTMLElement).style.color = '#db2d20';
        //         (input as HTMLElement).style.borderBottomColor = '#db2d20';
        //     } else {
        //         const input = document.querySelector('#prnt');
        //         (input as HTMLElement).style.color = '#32d13f';
        //         (input as HTMLElement).style.borderBottomColor = '#32d13f';
        //     }
        // }
    }
}
